import {spotheroPatch} from 'api';
import {ApiResponse} from 'api/api.types';
import {sendSentryException} from 'utils/error-handling';
import {camelizeKeys} from 'utils/format-strings';
import {BlackoutRequest, Blackout} from './blackouts.types';

/**
 * Formats the response from the update blackout API call
 */
const formatUpdateBlackoutResponse = (response: ApiResponse<Blackout>) => {
    const formattedResponse: Blackout = camelizeKeys(response.data.data);

    return formattedResponse;
};

interface UpdateBlackoutParams {
    facilityId: number;
    blackoutId: string;
    blackout: BlackoutRequest;
}

/**
 * Updates a facility blackout
 *
 * @param facilityId - The id of the facility the blackout belongs to
 * @param blackoutId - The id of the blackout to update
 * @param blackout - The updated blackout data
 *
 * @see '/api/v1/facilities/{facilityId}/blackouts/{blackoutId}/'
 */
const updateBlackout = async ({
    facilityId,
    blackoutId,
    blackout,
}: UpdateBlackoutParams) => {
    try {
        const response = await spotheroPatch<Blackout, BlackoutRequest>(
            `facilities/${facilityId}/blackouts/${blackoutId}/`,
            blackout
        );

        const formattedResponse: Blackout =
            formatUpdateBlackoutResponse(response);

        return formattedResponse;
    } catch (error) {
        sendSentryException(error);
        throw error;
    }
};

export default updateBlackout;
